<template>
    <div class="container">
        <div class="header">
            <img src="/images/zeiterfassung_header.svg" alt="titelbild" class="header-img">
        </div>
        <div class="main">
            <div class="form">
                <h3>Login</h3>
                <div class="microsoft-login-btn">
                    <a @click.prevent="loginWithMicrosoft()">
                        <img src="/images/microsoft-login-light.svg" alt="Microsoft Login" class="microsoft-login-img">
                    </a>
                </div>
                <div v-if="microsoftError" class="microsoft-error">
                    <span class="txt-warning">
                        {{ microsoftError }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from 'vue'
import {useRouter} from '@/composition-api'
import {useMicrosoftAuthService} from '@/config/useMicrosoftAuth'

export default defineComponent({
    /**
     * Component constructor.
     */
    setup() {
        const router = useRouter()
        const microsoftAuth = useMicrosoftAuthService()

        const microsoftError = ref<string | null>(null)

        onMounted(() => {
            if (router.currentRoute.query.error) {
                microsoftError.value = router.currentRoute.query.error as string
            }
        })

        const loginWithMicrosoft = async () => {
            microsoftError.value = null
            try {
                await microsoftAuth.initialize()
                await microsoftAuth.login()
            } catch (error: any) {
                console.error('Authentication error:', error)
                microsoftError.value = 'Die Anmeldung mit Microsoft ist fehlgeschlagen'
            }
        }

        return {
            loginWithMicrosoft,
            microsoftError,
        }
    }
})
</script>

<style scoped>
.microsoft-login-btn {
    cursor: pointer;
    text-align: center;
    margin-bottom: 24px;
}

.microsoft-error {
    margin-bottom: 24px;
}
</style>
